import BaseSecondaryStickyView from "scripts/views/baseSecondaryStickyNavView";
import templateLegalNoticesNav from "templates/legalNoticesPageNav.hbs";

class LegalNoticesNavView extends BaseSecondaryStickyView {
  get template() {
    return templateLegalNoticesNav;
  }

  shouldStick() {
    return true;
  }

  updateLinkState() {
    if (this.model.get("eula")) {
      $("#bb-legal-notices-page-nav-eula-sub-page-link")
        .closest("li")
        .addClass("active");
    } else {
      $("#bb-legal-notices-page-nav-privacy-sub-page-link")
        .closest("li")
        .addClass("active");
    }
  }
}

export default LegalNoticesNavView;
